
import { DocumentRequirementModel } from './document-requirement.model';

export class DocumentModel {
    public documentViewId: number;
    public documentId: number;
    public documentDescription: string;
    public documentContent: string;
    public documentFileName: string;
    public documentReviewStatusTypeId: number;
    public signatureRequired: boolean;
    public signatureComment: string;
    public documentRequirements: DocumentRequirementModel[] = new Array<DocumentRequirementModel>();
    public documentSize: number;
    public isScan: boolean;
    public mimeType: string;
}
